import { HttpParams } from '@angular/common/http';

export class HttpQueryParameter {
	getHttpQueryParams(): HttpParams {
		let params: HttpParams = new HttpParams();

		// TODO: Rauswerfen, wenn alle Pagination-Endpunkte geprüft sind!
		// @ts-ignore
		// tslint:disable-next-line:no-string-literal
		if (this['pageSize']) {
			// @ts-ignore
			// tslint:disable-next-line:no-string-literal
			this['limit'] = this['pageSize'];
		}

		const keyValuePairs = Object.entries(this);

		keyValuePairs.forEach(
			([key, value]: any) => {
				if (value === null || value === undefined) {
					return;
				}
				if (Array.isArray(value)) {
					params = this.handleArrayParams(value, params, key);
				} else {
					const trimmedValue = value?.toString()?.trim();
					params = params.set(key, trimmedValue || ''); // filter undefined & null values
				}
			}
		);
		return params;
	}

	private handleArrayParams(value: any[], params: HttpParams, key: string): HttpParams {
		value.forEach((entry: any) => {
			// tslint:disable-next-line:no-parameter-reassignment
			params = params.append(key, entry);
		});
		return params;
	}
}
